
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.826 12.131c-3.896.446-7.778 3.675-7.938 8.288-.101 2.817.68 4.93 3.296 5.524 1.135-2.053-.366-2.505-.6-3.99-.959-6.083 6.849-10.232 10.935-5.985 2.827 2.941.966 11.99-3.594 11.049-4.367-.898 2.138-8.1-1.348-9.515-2.834-1.15-4.34 3.515-2.997 5.833-.787 3.984-2.483 7.74-1.796 12.737 2.227-1.656 2.978-4.827 3.593-8.133 1.12.696 1.717 1.42 3.146 1.533 5.267.418 8.208-5.387 7.49-10.741-.64-4.747-5.263-7.163-10.187-6.6z","fill":"#fff"}})])
          )
        }
      }
    